
import './style.scss';
import {Link, useParams} from "react-router-dom";
import {useTranslation} from "lb-store";


const AccountControl = ({setRoute}) => {
    const { lang, ['*']: path } = useParams();
    const {t} = useTranslation();
    return (
        <>
            <div className="ac-content">
                <h2>{t('პასუხისმგებლიანი თამაში')}</h2>
                <br/>
                <p>{t('da_text_1')}</p>
                <div style={{marginLeft: '20px'}}>
                    <ul style={{listStyle: "disc", color: '#bac1c1'}}>
                        <li>{t('da_text_2')}</li>
                        <li>{t('da_text_3')}</li>
                        <li>{t('da_text_5')}</li>
                        <li>{t('da_text_6')}</li>
                        <li>{t('da_text_7')}</li>
                        <li>{t('da_text_8')}</li>
                        <li>{t('da_text_9')}</li>
                        <li>{t('da_text_10')}</li>
                        <li>{t('da_text_11')}</li>
                    </ul>
                </div>
                <br/>
                <p>{t('da_text_12')}</p>
                <br/>
                <p>{t('ანგარიშის დასაბლოკად')} <a style={{color: '#ffe32c'}} onClick={() => setRoute('personal-info')}>{t('ეწვიეთ ბმულს')}</a></p>
            </div>
        </>
    )
}

export default AccountControl;